import { render, staticRenderFns } from "./superCollectPack.vue?vue&type=template&id=3d0bdc38&"
import script from "./superCollectPack.vue?vue&type=script&lang=js&"
export * from "./superCollectPack.vue?vue&type=script&lang=js&"
import style0 from "./superCollectPack.vue?vue&type=style&index=0&id=3d0bdc38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports